import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'
import { createSelector } from '@reduxjs/toolkit'

const selectCommonUsers = (state: StoreSchema) => state.commonData.common.users
const selectLicenseUpdates = (state: StoreSchema) => state.licenseUpdates.paginatedLicenseUpdates.items

export const selectModifiedLicenseUpdates = createSelector(
	[selectLicenseUpdates, selectCommonUsers],
	(licenseUpdates, users) => {

		return licenseUpdates.map((update) => {
			const manager = users.find((user) => user.userId === update.userId)
			const updateTime = update.updateTime.slice(0, 19).split('T').join(' ')
			const expirationDate = update.expirationDate.slice(0, 19).split('T').join(' ')

			const preset = update.functionalityPresetId && update.presetNameSnapshot

			const funcSet = update.functionalitiesSet
			const functionalities = Array.isArray(funcSet) &&
				!!funcSet.length &&
				funcSet.map(set => (
					[set.functionalityNameSnapshot, set.value ?? set.validators])
				)

			const parameter = preset ? preset : functionalities ? functionalities : null

			return {
				...update,
				updateTime,
				expirationDate,
				manager: manager?.fullName || 'SYSTEM',
				parameter,
				updateReason: update.updateReason
			}
		})
	})
